import type { SVGProps } from 'react';

const SvgPaperMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M15 20H5C4.44771 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V15M15 20L20 15M15 20V16C15 15.4477 15.4477 15 16 15H20M9 9L15 9M9 12L15 12M9 15H12'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
    />
  </svg>
);
export default SvgPaperMd;
